import { render, staticRenderFns } from "./shift-form-fields.vue?vue&type=template&id=31b58814&scoped=true&"
import script from "./shift-form-fields.vue?vue&type=script&lang=js&"
export * from "./shift-form-fields.vue?vue&type=script&lang=js&"
import style0 from "./shift-form-fields.vue?vue&type=style&index=0&id=31b58814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b58814",
  null
  
)

export default component.exports